import { LOCATION_CHANGE } from 'react-router-redux';

const INITIAL_STATE = { locationBeforeTransitions: null };

export default function route(state = INITIAL_STATE, action) {
  if (action.type === LOCATION_CHANGE) {
    return {
      ...state,
      locationBeforeTransitions: action.payload
    };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/routing.js